import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';
import {
  INFLUENCER_APP_ANDROID_LINK,
  INFLUENCER_APP_IOS_LINK
} from 'utils/mobile-app';

import type { AvailableMobilePlatforms } from 'utils/mobile-app';

applyTranslations(require('./mobile-banner.i18n.json'));

type Props = {
  platform: AvailableMobilePlatforms | null
};

class MobileBanner extends React.PureComponent<Props> {
  getLink(platform?: string | null): string {
    if (platform === 'android') {
      return INFLUENCER_APP_ANDROID_LINK;
    }

    return INFLUENCER_APP_IOS_LINK;
  }

  render(): React.ReactNode {
    const { platform } = this.props;

    return (
      <section className="mobile-banner">
        <div className="mobile-banner__inner">
          <div className="mobile-banner__content">
            <div className="mobile-banner__icon" />
            <div className="mobile-banner__info">
              <div className="mobile-banner__info-title">
                {__t('mobile_banner.title')}
              </div>
              <div className="mobile-banner__info-message">
                {__t('mobile_banner.message')}
              </div>
            </div>
          </div>
          <a
            href={this.getLink(platform)}
            className="mobile-banner__action-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            {__t('mobile_banner.button')}
          </a>
        </div>
      </section>
    );
  }
}

export default MobileBanner;
